import WelcomeBanner from '../../components/banner/Welcome';
import EarningLossPerMonthCard from '../../components/charts/ProfitLossPerMonthCard';
import OverallValueCard from '../../components/charts/OverallValueCard';
import RecentEarningAndLossCard from '../../components/charts/RecentEarningAndLossCard';
import StocksOnHandByIndustryCard from '../../components/charts/StocksOnHandByIndustryCard';
import TopEarningStockCard from '../../components/charts/TopEarningStockCard';
import RecentActivitiesTable from '../../components/tables/RecentActivitiesTable';
import {
  DUMMY_EARNING_LOSS_PER_MONTH,
  DUMMY_STOCKS_ON_HAND_BY_SECTOR,
  DUMMY_TOP_STOCK,
} from '../../dummy_data/Dummy_Dashboard';
import {
  DUMMY_EARNING_AND_LOSS,
  DUMMY_RECENT_ACTIVITIES,
} from '../../dummy_data/Dummy_RecentActivities';
import { FormatMoneyToDisplay } from '../../helper/currency-helper';
import TopProfitByIndustryCard from '../../components/charts/TopEarningIndustryCard';
import ProfitLossByIndustryPerMonthCard from '../../components/charts/ProfitLossByIndustryPerMonth';

const LandingPage = () => {
  return (
    <>
      <WelcomeBanner />
      <div className="grid grid-cols-12 gap-6">
        {/* Overall Profit */}
        <OverallValueCard
          title="Overall Profit"
          value={FormatMoneyToDisplay(24780)}
          isPositiveValue={true}
          badgeValue={49}
        />
        {/* Average Profit/Loss*/}
        <OverallValueCard
          title="Average Profit/Loss"
          value={FormatMoneyToDisplay(-1022.23)}
          isPositiveValue={false}
          badgeValue={-23}
        />
        {/* Average Holding Period */}
        <OverallValueCard title="Average Holding Period" value="14 Days" />
        <TopEarningStockCard topEarningStocksDetails={DUMMY_TOP_STOCK} />
        <EarningLossPerMonthCard data={DUMMY_EARNING_LOSS_PER_MONTH} />
        <RecentActivitiesTable data={DUMMY_RECENT_ACTIVITIES} />
        <RecentEarningAndLossCard data={DUMMY_EARNING_AND_LOSS} />
        <StocksOnHandByIndustryCard
          chartData={DUMMY_STOCKS_ON_HAND_BY_SECTOR}
        />
        <TopProfitByIndustryCard data={DUMMY_STOCKS_ON_HAND_BY_SECTOR} />
        <ProfitLossByIndustryPerMonthCard
          data={DUMMY_STOCKS_ON_HAND_BY_SECTOR}
        />
      </div>
    </>
  );
};

export default LandingPage;
